import { useEffect } from 'react';

// Exported for unit tests. A mousedown dismisses the panel only when the panel
// is open and the click landed neither inside it nor on a control that already
// owns the panel's open/close toggle — those would otherwise close on mousedown
// and immediately reopen on the following click.
export const shouldCloseOnOutsideClick = ({ isOpen, panelEl, target, ignoreSelector }) => {
    if (!isOpen || !target) return false;
    if (panelEl?.contains(target)) return false;
    if (ignoreSelector && target.closest?.(ignoreSelector)) return false;
    return true;
};

const useCloseOnOutsideClick = ({ isOpen, panelRef, onClose, ignoreSelector }) => {
    useEffect(() => {
        if (!isOpen) return undefined;
        const handleMouseDown = (event) => {
            if (shouldCloseOnOutsideClick({ isOpen, panelEl: panelRef.current, target: event.target, ignoreSelector })) onClose();
        };
        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, [isOpen, panelRef, onClose, ignoreSelector]);
};

export default useCloseOnOutsideClick;
